(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["about-us"]) return;
  try {
    


jQuery(document).ready(function() {

$(".inline").colorbox({inline:true, width:"50%"});
});




$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

jQuery("#client-car").owlCarousel({   
navigation: false,
items : 5,
itemsDesktop : [1200,4],
itemsTablet: [767,4],
itemsTabletSmall: [721,3],
itemsMobile : [479,2],
});
});







  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["client-logos"] && !window.DesignMode) return;
  try {
    



$(document).ready(function() {
jQuery("#client-car").owlCarousel({   
       loop:true,
        margin:10,
        nav:false,       
        dots: true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:3
            },
            1000:{
                items:6
            }
        }
    });
  });





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-banner-type-1"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
     
      $('#carousel_banner').owlCarousel({       
       items:1,
       loop:true,      
       dots: true, 
	   autoplay: true,
	   autoplayTimeout: 3000,
       responsive:{
         0:{
           items: 1
         },
         600:{
           items:1
         },
         1000:{
           items: 1
         }
       }
});
  });

      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-category"]) return;
  try {
    
$(document).ready(function(){
  $(".dt-menu-expand").click(function(event){
    event.preventDefault();
    if( $(this).hasClass("dt-mean-clicked") ){
      $(this).text("+");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
      } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
      }
    } else {
      $(this).text("-");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
      } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
      }
    }

    $(this).toggleClass("dt-mean-clicked");
    return false;
  });

});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    

if (jQuery.cookie('headerTop') == 'closed') {
jQuery('.header-top').fadeOut();
}

jQuery('.header-top a.close').bind('click',function(){
jQuery('.header-top').fadeOut();
jQuery.cookie('headerTop', 'closed', {expires:-1, path:'/'});
});  

  } catch(e) { console.error(e); }
})();

})();
